import React from 'react';
import PropTypes from 'prop-types';

import {useHistory, useParams} from "react-router-dom";
import CustomButton from "components/CustomButton";

import ButtonActionContainer from "./ButtonActionContainer";

import {black500} from "assets/jss/main";
import {MarketplaceRoutes} from "utils/MarketplaceRoutes";

SeeErrorButton.propTypes = {
    importReport: PropTypes.object.isRequired,
};

const EyeIcon = () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={black500}
         strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="lucide lucide-eye h-3 w-3 mr-1">
        <path
            d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0"></path>
        <circle cx="12" cy="12" r="3"></circle>
    </svg>
)

function SeeErrorButton({importReport}) {
    const history = useHistory();
    const {id: retailerId, fid: feedId} = useParams();

    function displayImportDetail() {
        const reportId = importReport['@id'].replace('/import_reports/', '');

        history.push({
            pathname: MarketplaceRoutes.RETAILER_FEEDS_HISTORY_IMPORT_REPORT(retailerId, feedId, reportId),
            type: "parent",
        });
    }

    return (
        <CustomButton
            variant={'transparent'}
            color={'default'}
            noBorder
            onClick={(e) => {
                e.stopPropagation();
                displayImportDetail()
            }}
        >
            <ButtonActionContainer>
                <EyeIcon/> Voir erreurs
            </ButtonActionContainer>
        </CustomButton>
    );
}

export default SeeErrorButton;
